export const setupComplete = function (bakergames,standardgames) {
    return (((bakergames != undefined) && (parseInt(bakergames) > 0)) ||
            ((standardgames != undefined) && (parseInt(standardgames) > 0)))
 }    


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Logic/setupComplete.js